import {
  FC,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useContext,
} from 'react';

import { Button, InfoIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { isSandbox } from 'sandbox';

import s from './ReleaseChecker.module.scss';

export const ReleaseChecker: FC = () => {
  const { t } = useContext(LocalizationContext);

  const currentVersion = process.env.REACT_APP_VERSION;
  const [lastVersion, setLastVersion] = useState<string | null>();

  const loadData = useCallback(() => {
    if (isSandbox) return Promise.resolve();

    return fetch('/version.txt', {
      cache: 'no-store',
    })
      .then((response) => {
        if (response.status !== 200) throw new Error('Ошибка');
        return response.text();
      })
      .then((text) => setLastVersion(text.trim()))
      .catch((error) => console.error(error.message));
  }, []);

  useEffect(() => {
    if (isSandbox) return;
    const interval = setInterval(loadData, 300000);

    return () => clearInterval(interval);
  }, []);

  const shouldNotify = useMemo<boolean>(() => {
    if (!currentVersion || !lastVersion) return false;

    const [currMaj, currMin] = currentVersion?.split('.');
    const [lastMaj, lastMin] = lastVersion?.split('.');

    return currMaj !== lastMaj || currMin !== lastMin;
  }, [currentVersion, lastVersion]);

  if (!shouldNotify) return null;

  return (
    <div className={cn(s.container)}>
      <div className={s.icon}>
        <InfoIcon />
      </div>
      <div className={s.content}>
        <div className={s.description}>
          <span className={s.title}>{t('version.new.title')}</span>
          <span>{t('version.new.description')}</span>
        </div>
        <Button
          onClick={() => location.reload()}
          variant="outline"
          className={s.reload}
          size="s"
          iconName="RestartIcon"
        >
          {t('version.new.submit')}
        </Button>
      </div>
    </div>
  );
};
